<template>
    <div ref="field" class="textarea-area" :class="[size, {'ui-input-group': group || groupicon}, {'invert-order': invertgroup}, {'error': error}]">
        <label v-if="label" class="label-textarea">
            <div>
                <span :style="{'color' :labelColor}" v-html="label" />
                <span v-if="required" class="label-required">*</span>
            </div>
            <div class="label-right">
                <span v-html="rightLabel" />
            </div>
        </label>
        
        <textarea
            :ref="refer"
            :type="type"
            :name="name"
            :value="valueComputed"
            :class="design"
            :disabled="disabled"
            :rows="rows"
            :readonly="readonly"
            :placeholder="placeholder"
            :required="required"
            :style="{'background-color': backgroundColor}"
            autocomplete="off"
            @input="change"
            @focus="clearError"
            @blur   = "onBlur"
            @reset  = "onReset"
            @submit = "onSubmit"
            @select = "onSelect"/>

        <span v-if="message" class="message">
            {{ message }}
        </span>

        <div v-if="observation" class="observation-message">
            {{ observation }}
        </div>

        <span v-if="group" class="group">
            {{ group }}
        </span>

        <span v-if="groupicon" class="group">
            <i :class="groupicon"/>
        </span>
    </div>
</template>

<script>
    import { number } from '@/directives'

    export default {
        name: 'ui-input',

        directives: {
            number,
        },

        props: {
            /**
			 * Utilize para aplicar as o texto da label
			 */
            label: {
                type: String,
                required: false,
                default: ''
            },
            /**
             * altera a cor do label
             */
             labelColor: {
                type: String,
                default: ''
            },
            /**
			 * Utilize para alterar o tipo do input
			 */
            type: {
                type: String,
                required: false,
                default: 'text'
            },
            /**
			 * Utilize para referenciar a label a um input
			 */
            refer: {
                type: String,
                required: false,
                default: ''
            },
            /**
			 * Utilize para colocar um nome no input
			 */
            name: {
                type: String,
                required: false,
                default: ''
            },
            /**
			 * Utilize para acessar o valor do input
			 */
            // eslint-disable-next-line vue/require-default-prop, vue/require-prop-types
            value: {
                required: false,
            },
            /**
                ativa uma quantidade de linhas
             */
            rows: {
                type: String,
                default: '4',
                required: false
                },
            /**
			 * Utilize para aplicar alterar entre os estilos de input
			 */
            design: {
                type: [String, Object],
                required: false,
                default: ''
            },
            /**
             * Controle de background-color do elemento
             */
             backgroundColor: {
                type: String,
                required: false,
                default:'transparent'
            },
            /**
			 * Utilize para aplicar mask no input
			 */
            mask: {
                type: String,
                required: false,
                default: ''
            },
            /**
			 * Utilize para alterar o tamanho do input
			 */
            size: {
                type: String,
                required: false,
                default: ''
            },

            /**
             * Utilize para ter um botao ou label  na mesma linha que o input
             */
            group: {
                type: String,
                required: false,
                default: ''
            },

            /**
             * Utilize para adicionar um icone no group
             */
            groupicon: {
                type: String,
                required: false,
                default: ''
            },

            /**
             * Utilize para inverter a posição do 'group'
             * por padrão fica do lado direito
             */
            invertgroup: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Utilize para desabilitar o input
             */
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Define a propriedade readonly do input
             */
            readonly: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Ativa a diretiva Permite apenas que o input receba apenas
             * números e pontos (para valores flutuantes)
             */
            number: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * define o input como required em html5 e aplica o operador '*' na label
             */
            required: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Utilize para aplicar o estado de error no input
             */
            error: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Mensagens de validação ou observação.
             */
             observation:{
                type: String,
                default: ''
            },

            /**
             * Utilize para mostrar mensagens de feedback abaixo do input
             */
            message: {
                type: String,
                required: false,
                default: ''
            },
            
            /**
             * Ativa a diretiva Permite apenas que o input receba apenas
             * números e pontos (para valores flutuantes)
             */
            percent: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
             *Coloca um exemplo no input
             */
            placeholder: {
                type: String,
                required: false,
                default: null
            },
            /**
			 * Utilize para remover a mensagem de erro ao receber foco
			 */
            clearErrorOnFocus:{
                type: Boolean,
                required: false,
                default: true
            },
            rightLabel: {
                type: String,
                required: false,
                default: ''
            }
        },

        computed: {
            /**
             * Computed property para retornar os valores com as casas decimais formatadas
             * com vírgula
             */
            valueComputed() {
                if (this.percent) return this.value ? this.value.replace('.', ',') : null

                return this.value
            }
        },

        methods: {
            /**
             * Trata o evento de quando um valor é digitado no input
             */
            change(event) {
                if (this.percent) {
                    this.percentegeHandler(event)
                    this.$emit('input', event.target.value ? event.target.value.replace(',', '.') : null)

                } else {
                    if(this.number) this.numberHandler(event)
                    this.$emit('input', event.target.value)
                }
            },
			onInput (event) {
                this.$emit('input', event.target.value)
            },
            onFocus(){
                /* Comportamento padrão do input ao receber foco */
                if(this.clearErrorOnFocus){
                    this.clearError()
                }
                this.$emit('focus', event.target.value) 
            },
            onBlur(){
                this.$emit('blur', event.target.value)
            },
            onReset(){
                this.$emit('reset', event.target.value)
            },
            onSubmit(){
                this.$emit('submit', event.target.value)
            },
            onSelect(){
                this.$emit('select', event.target.value)
            },
            clearError(){
                // this.$refs.field.classList.remove('error')
            },

            /**
             * Remove todos os caracteres que não são numéricos
             */
            numberHandler(event) {
                let regex = /^\d*$/

                if (!regex.test(event.target.value)) {
                    event.target.value = event.target.value.slice( 0, -1 )
                }

                event.target.value = this.isInt(event.target.value) ? event.target.value : null
            },

            /**
             * Remove todos os caracteres que não são numéricos e aceita um ponto
             * Usado para números flutuantes
             */
            percentegeHandler(event) {
                let regex = /^\d*[,]?\d*$/

                if (!regex.test(event.target.value)) {
                    event.target.value = event.target.value.slice(0, -1)
                }

                event.target.value = this.isFloat(event.target.value) ? event.target.value : null
            },

            /**
             * Checks whether a value is an integer
             */
            isInt(value) {
                let intRegex = /^-?\d+$/
                if (!intRegex.test(value))
                    return false

                let intValue = parseInt(value, 10)
                return parseFloat(value) == intValue && !isNaN(intValue)
            },

            /**
             * Checks whether a value is an float
             */
            isFloat(value) {
                let floatRegex = /^-?\d+(?:[.,]\d*?)?$/
                if (!floatRegex.test(value))
                    return false

                value = parseFloat(value);
                if (isNaN(value))
                    return false
                return true
            },
        }
    };
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>